
import { Vue, Prop, Component, Model } from 'nuxt-property-decorator';
import { InputSelect } from 'fourwaves-shared/components';
import MoneyInput from '~/components/form/MoneyInput.vue';

@Component({
  components: {
    InputSelect,
    MoneyInput,
  },
})
export default class CheckoutTermLength extends Vue {
  @Prop({ type: Number, required: true }) readonly currentTermLength!: number;
  @Prop(Boolean) readonly disabled!: boolean;
  @Prop(Boolean) readonly customPlanMode!: boolean;
  @Prop(Boolean) readonly renew!: boolean;

  @Model('change', { type: Number, default: null }) readonly value!: number;

  get options() {
    return [
      {
        id: 1,
        label: this.$t('checkout.term_length.one_year'),
        disabled: this.renew ? false : this.currentTermLength > 1,
      },
      {
        id: 2,
        label: this.$t('checkout.term_length.two_year'),
        disabled: this.renew ? false : this.currentTermLength > 2,
      },
      { id: 3, label: this.$t('checkout.term_length.three_year') },
    ];
  }

  get isInputSelectVisible() {
    if (this.customPlanMode) return false;
    return this.renew ? true : this.currentTermLength < 4;
  }

  get customModeValidation() {
    const minValue = this.renew ? 1 : this.currentTermLength;
    return {
      required: true,
      min_value: minValue,
    };
  }
}
